import React from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { withContent } from 'components/Content';
import RichText from 'components/RichText';
import Button from 'components/ContentfulFields/Button';
import { injectVariables } from 'utils/translation';
import { getRegionalBrandName } from 'utils/domainHelper';
import { selectAcquisitionVariables } from 'containers/Landing/selectors';

import styles from './summary.scss';

const CONTENT_KEYS = {
  header: 'Header',
  features: 'Features',
  footerDesc: 'Footer Desc',
  cta: 'Corporate Responsibility',
};

const Summary = ({ content }) => {
  const { header, features, footerDesc, cta } = content;
  const acquisitionVariables = useSelector(selectAcquisitionVariables());

  const options = {
    renderText: (text) => {
      const regionalBrandName = getRegionalBrandName();

      return injectVariables(
        injectVariables(text, regionalBrandName, acquisitionVariables, ''),
        regionalBrandName,
        acquisitionVariables,
        '',
      );
    },
  };

  return (
    <section className={styles.summary}>
      <div className={styles.header}>
        <RichText richText={header.fields.richText} />
      </div>
      <div className={styles.features}>
        {features.fields.features.map((feature) => {
          const { title, description, images } = feature.fields;
          return (
            <div key={feature.sys.id} className={styles.feature}>
              <img
                src={`${get(images, '[0].fields.file.url')}?fm=webp`}
                alt=""
                aria-hidden="true"
              />
              <p className={styles.title}>{title}</p>
              <div className={styles.desc}>
                {documentToReactComponents(description, options)}
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.footer}>
        <p>{footerDesc}</p>
        <Button className={styles.cta} document={cta} />
      </div>
    </section>
  );
};

export default withContent(CONTENT_KEYS)(Summary);
